const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('flarum-markdown', 'common/components/MarkdownButton');